import React, { useState } from 'react';
import { Button, Input, Form, Select, Row, Col, Typography, DatePicker } from 'antd';
import { SearchOutlined, DeleteOutlined } from '@ant-design/icons';
import { Link } from 'react-router-dom';
import { TableCustom } from '../../../components/TableCustom';
import { useQuery } from '@tanstack/react-query';
import { getListUserFeaturesRequest, listFeaturesRequest } from '../../../services/cms/userFeatureServiceRequest';
import { newObjectKeys } from '../../../utils/utility';

const { Text } = Typography;

const QuanLyUserFeature = () => {
  const [formSearch] = Form.useForm();
  const [params, setParams] = useState({ page: 1, limit: 20 });

  const { data: dataUserFeatures } = useQuery({
    queryKey: ['dataUserFeatures', params],
    queryFn: () => getListUserFeaturesRequest(params),
  });

  const { data: features } = useQuery({
    queryKey: ['allFeatures'],
    queryFn: () => listFeaturesRequest({}),
  });

  const handleSubmitForm = (values) => {
    const temp = { page: 1, limit: params.limit };
    if (values?.user_id) Object.assign(temp, { user_id: values.user_id });
    if (values?.feature_id) Object.assign(temp, { feature_id: values.feature_id });
    if (values?.start_date) Object.assign(temp, { start_date: values.start_date.format('YYYY-MM-DD') });
    if (values?.end_date) Object.assign(temp, { end_date: values.end_date.format('YYYY-MM-DD') });
    setParams(temp);
  };

  // Issue #1: tách Thời hạn thành 2 cột riêng
  const columns = [
    { title: 'ID', dataIndex: 'id', key: 'id' },
    { title: 'User ID', dataIndex: 'user_id', key: 'user_id', render: (id) => (id ? <Link to={`/cms/quan-ly-user/${id}`} className="text-blue-600 hover:text-blue-800 font-bold">{id}</Link> : '-') },
    { title: 'Tính năng', dataIndex: 'feature_name', key: 'feature_name' },
    { title: 'Thời gian bắt đầu', dataIndex: 'start_time', key: 'start_time' },
    { title: 'Thời gian kết thúc', dataIndex: 'end_time', key: 'end_time' },
  ];

  return (
    <div className="m-5">
      <div className="flex justify-between items-center mb-5">
        <h1 className="text-2xl">Quản lý User Feature</h1>
      </div>
      <Form name="search_user_features" form={formSearch} layout="vertical" requiredMark={false} className="mb-5" onFinish={handleSubmitForm}>
        <Row gutter={[16, 16]}>
          <Col xs={24} sm={12} md={8} xl={6}>
            <Form.Item name="user_id" label={<Text>User ID</Text>}>
              <Input placeholder="Nhập User ID" type="number" />
            </Form.Item>
          </Col>
          <Col xs={24} sm={12} md={8} xl={6}>
            <Form.Item name="feature_id" label={<Text>Tính năng</Text>}>
              <Select showSearch allowClear placeholder="Chọn tính năng"
                filterOption={(input, option) => (option?.label ?? '').toLowerCase().includes(input.toLowerCase())}
                options={features?.map(f => ({ value: f.id, label: f.display_name || f.name })) || []}
              />
            </Form.Item>
          </Col>
          {/* 2 filter độc lập: mỗi ô khớp đúng 1 ngày trên cột cùng tên trong bảng */}
          <Col xs={24} sm={12} md={8} xl={6}>
            <Form.Item name="start_date" label={<Text>Thời gian bắt đầu</Text>}>
              <DatePicker format="DD/MM/YYYY" className="w-full" placeholder="Chọn ngày" />
            </Form.Item>
          </Col>
          <Col xs={24} sm={12} md={8} xl={6}>
            <Form.Item name="end_date" label={<Text>Thời gian kết thúc</Text>}>
              <DatePicker format="DD/MM/YYYY" className="w-full" placeholder="Chọn ngày" />
            </Form.Item>
          </Col>
          <Col className="flex items-center gap-2">
            <Button type="primary" htmlType="submit"><SearchOutlined /> Tìm kiếm</Button>
            {params && Object.values(newObjectKeys(params, ['user_id', 'feature_id', 'start_date', 'end_date'])).some((value) => value) && (
              <Button htmlType="button" onClick={() => { formSearch.resetFields(); setParams({ page: 1, limit: params.limit }); }}>
                <DeleteOutlined /> Xóa lọc
              </Button>
            )}
          </Col>
        </Row>
      </Form>
      <TableCustom columns={columns} dataSource={dataUserFeatures?.data} totalItem={dataUserFeatures?.total} params={params} setParams={setParams} />
    </div>
  );
};

export default QuanLyUserFeature;
